<div class="chart-container" [style]="style">
    <canvas baseChart
        [type]="bubbleChartType"
        [data]="bubbleChartData"
        (chartClick)="onSelect($event)"
        [options]="bubbleChartOptions"
        [plugins]="bubblePlugins">
    </canvas>
</div>
